import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tekh-di',
  templateUrl: './tekh-di.component.html',
  styleUrls: ['./tekh-di.component.scss']
})
export class TekhDiComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
